type Props = {
    svgProps?: React.SVGProps<SVGSVGElement>
    iconColor?: string
}

export const ChainIcon = () => {
    return (
        <svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.69272 0H3.75C1.67893 0 0 1.67893 0 3.75C0 5.82107 1.67893 7.5 3.75 7.5H7.5C9.57107 7.5 11.25 5.82107 11.25 3.75C11.25 3.31171 11.1748 2.89097 11.0366 2.5H10C9.8922 2.5 9.78759 2.51364 9.68781 2.5393C9.88673 2.898 10 3.31077 10 3.75C10 5.13071 8.88071 6.25 7.5 6.25H3.75C2.36929 6.25 1.25 5.13071 1.25 3.75C1.25 2.36929 2.36929 1.25 3.75 1.25H5.66891C5.94108 0.779494 6.28772 0.357455 6.69272 0Z" fill="#131313" />
            <path d="M10 0C7.92893 0 6.25 1.67893 6.25 3.75C6.25 4.18829 6.32519 4.60903 6.46338 5H7.83446C7.62174 4.63228 7.5 4.20536 7.5 3.75C7.5 2.36929 8.61929 1.25 10 1.25H13.75C15.1307 1.25 16.25 2.36929 16.25 3.75C16.25 5.13071 15.1307 6.25 13.75 6.25H11.8311C11.5589 6.72051 11.2123 7.14255 10.8073 7.5H13.75C15.8211 7.5 17.5 5.82107 17.5 3.75C17.5 1.67893 15.8211 0 13.75 0H10Z" fill="#131313" />
        </svg>

    )
}
